module.exports = __webpack_public_path__ + "img/design-icons.202e4732.jpg";